<template>
  <!-- <fragment> -->
  <base-label :text="label" /> <br />
  <base-input
    type="text"
    :placeholder="placeholder"
    :value="value"
    @input="onInput"
  />
  <!-- </fragment> -->
</template>
<script>
export default {
  components: {},
  name: "UiDynamicForm",
  data() {
    return {
      input: "",
    };
  },
  props: {
    placeholder: { required: true },
    value: { required: true },
    label: { required: true },
  },
  methods: {
    onInput(e) {
      this.input = e;
      this.$emit("input", this.input);
    },
  },
};
</script>
